module.exports = __webpack_public_path__ + "img/xsss1.c1fce59a.png";